import { getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { mainApi } from "api";
import { toast } from "react-toastify";
import MainApiRoutes from "const/MainApiRoutes";

export default class ActivityActions {
  static FETCH_ACTIVITY_LIST_START = "activity/FETCH_ACTIVITY_LIST_START";

  static FETCH_ACTIVITY_LIST_DONE = "activity/FETCH_ACTIVITY_LIST_DONE";

  static FETCH_ACTIVITY_LIST_ERROR = "activity/FETCH_ACTIVITY_LIST_ERROR";

  static FETCH_STATS_START = "activity/FETCH_STATS_START";

  static FETCH_STATS_DONE = "activity/FETCH_STATS_DONE";

  static FETCH_STATS_ERROR = "activity/FETCH_STATS_ERROR";

  static fetchActivityList(filters, offset, limit, clearList = false, backgroundUpdate = false) {
    return async(dispatch, getState) => {
      dispatch({ type: ActivityActions.FETCH_ACTIVITY_LIST_START, payload: { clearList, backgroundUpdate } });

      const { BUSINESSES, ACTIVITY } = MainApiRoutes;

      const selectedBusinessId = getSelectedBusinessId(getState());

      const { errors } = getTextsData(getState());

      const requestBody = {
        ...filters,
        ...(limit || limit === 0 ? { limit } : {}),
        ...(offset || offset === 0 ? { offset } : {})
      };

      const { results, hash } = await mainApi.post(
        `${BUSINESSES}/${selectedBusinessId}${ACTIVITY}`,
        null,
        requestBody
      );

      if (Array.isArray(results)) {
        dispatch({
          type: ActivityActions.FETCH_ACTIVITY_LIST_DONE,
          payload: { backgroundUpdate, data: results, dataHash: hash }
        });

        return results;
      }
      dispatch({ type: ActivityActions.FETCH_ACTIVITY_LIST_ERROR });
      toast.error(errors.whileLoadingActivity);

      return null;
    };
  }

  static fetchStats(clearList = false, backgroundUpdate = false) {
    return async(dispatch, getState) => {
      dispatch({ type: ActivityActions.FETCH_STATS_START, payload: { clearList, backgroundUpdate } });

      const { BUSINESSES, ACTIVITY, STATS } = MainApiRoutes;

      const selectedBusinessId = getSelectedBusinessId(getState());

      const { errors } = getTextsData(getState());

      const { results } = await mainApi.post(`${BUSINESSES}/${selectedBusinessId}${ACTIVITY}${STATS}`);

      if (Array.isArray(results)) {
        dispatch({
          type: ActivityActions.FETCH_STATS_DONE,
          payload: { backgroundUpdate, data: results }
        });

        return results;
      }
      dispatch({ type: ActivityActions.FETCH_STATS_ERROR });
      toast.error(errors.whileLoadingActivity);

      return null;
    };
  }
}
